<template>
  <div class="h-100 d-flex flex-column">
    <ProgramTaylorMade
      :exampleData="exampleData"
      :modal_message="modal_tailored"
      :watcherTaylorMade="watcherTaylorMade"
      @eventOnUserAccept="onUserAccept"
    />
    <Messages
      :colorTheme="colorTheme"
      :modal_message="modal_processing_message"
    />

    <Messages
      :colorTheme="colorTheme"
      :modal_message="modal_process_finished_message"
    />
    <div class="row f-row justify-content-start">
      <div
        class="txt-label-primary-2"
        style="width: 180px; justify-content: flex-start!important;"
      >
        <span style="padding-left: 10px!important;">Define program for:</span>
      </div>
      <div
        class="txt-label-primary-2"
        style="width: 80px; justify-content: flex-start!important;"
      >
        Portfolio:
      </div>
      <div class="col col-2 ml-2 mr-4">
        <Dropdown
          v-model="selPort"
          :options="portfolioList"
          @change="retrieveProgram"
          optionLabel="name"
          optionValue="pk"
          placeholder="Select a Portfolio"
          scrollHeight="400px"
          :filter="true"
        >
          <template #value="slotProps">
            {{ portfolioPkToString(slotProps.value) }}
          </template>
          <template #option="slotProps">
            <div class="country-item">
              <div>{{ slotProps.option.name }}</div>
            </div>
          </template>
        </Dropdown>
      </div>
      <div
        class="txt-label-primary-2"
        style="width: 80px; justify-content: flex-start!important;"
        v-if="selectedAsset === 0"
      >
        Currency:
      </div>
      <div class="col col-2 ml-2 mr-4" v-if="selectedAsset === 0">
        <Dropdown
          v-model="selCurr"
          :options="currencies"
          @change="retrieveCurrencyProgram"
          optionLabel="name"
          optionValue="pk"
          placeholder="Select a Portfolio"
          scrollHeight="400px"
          :filter="true"
        >
          <template #value="slotProps">
            {{ currencyPkToString(slotProps.value) }}
          </template>
          <template #option="slotProps">
            <div class="country-item">
              <div>{{ slotProps.option.name }}</div>
            </div>
          </template>
        </Dropdown>
      </div>
      <div
        class="txt-label-primary-2"
        style="width: 80px; justify-content: flex-start!important;"
        v-if="selectedAsset === 1"
      >
        Commodity:
      </div>
      <div class="col col-2 ml-2 mr-4" v-if="selectedAsset === 1">
        <Dropdown
          v-model="selComm"
          :options="commodities"
          @change="retrieveCommodityProgram"
          optionLabel="name"
          optionValue="pk"
          placeholder="Select a Portfolio"
          scrollHeight="400px"
          :filter="true"
        >
          <template #value="slotProps">
            {{ commodityPkToString(slotProps.value) }}
          </template>
          <template #option="slotProps">
            <div class="country-item">
              <div>{{ slotProps.option.name }}</div>
            </div>
          </template>
        </Dropdown>
      </div>
    </div>
    <div class="row f-row h-100 justify-content-around align-items-center">
      <div class="col program-div" style="margin: 0 5px 0 5px;">
        <!-- Balance Program -->
        <div class="row f-row h-50" v-if="selectedAsset === 0">
          <div
            class="col program-inner-div-1"
            v-bind:class="[
              radioSelection === 'balance'
                ? 'program-bgnd-light'
                : 'program-bgnd-dark',
            ]"
          >
            <div class="row f-row">
              <div class="col col-12" @click="onClickBalanceDiv">
                <input
                  type="radio"
                  id="balance"
                  value="balance"
                  v-model="radioSelection"
                />
                <label for="balance">
                  <span style="padding-left: 8px">
                    Hedging Program Objective:
                  </span>
                  <span style="color:var(--textactive)">Balance</span>
                </label>
              </div>
            </div>
            <div class="row f-row">
              <div class="col col-12">
                The exposure represents the net difference between foreign
                assets and liabilities in foreign currency, calculated as:
                <ul class="fa-ul">
                  <li>
                    <i class="fa-li fa fa-plus"></i>Foreign assets and accounts
                    receivable in foreign currency
                  </li>
                  <li>
                    <i class="fa-li fa fa-minus"></i>Liabilities and accounts
                    payable in foreign currency.
                  </li>
                </ul>
              </div>
            </div>
            <div class="row f-row">
              <div class="col col-12">
                Define Execution Rules: Please select the percentage (%) of the
                balance exposure to hedge:
              </div>
            </div>
            <div class="row f-row">
              <div class="col col-12">
                <ul class="fa-ul">
                  <li>
                    <i class="fa-li fa fa-check"></i>
                    <div class="row f-row">
                      <div class="col col-3">
                        <input
                          v-model.number.lazy="balancePercentage"
                          placeholder="%"
                          type="number"
                          step="1"
                          min="0"
                          max="200"
                          class="custom-input"
                        />
                      </div>
                      <div class="col col-6 ml-1">% (of balance exposure)</div>
                    </div>
                  </li>
                  <li v-if="this.selectedBalGradient !== 'expo'">
                    <i class="fa-li fa fa-check"></i>
                    <div class="row f-row">
                      <div class="col col-3">
                        <input
                          v-model.number.lazy="balanceMonths"
                          placeholder="months"
                          type="number"
                          step="1"
                          min="1"
                          max="60"
                          class="custom-input"
                        />
                      </div>
                      <div class="col col-6 ml-1">months.</div>
                    </div>
                  </li>
                  <li>
                    <i class="fa-li fa fa-check"></i>
                    <div class="row f-row">
                      <div class="col col-11" style="padding: 2px;">
                        <div
                          class="btn-toolbar"
                          role="toolbar"
                          aria-label="Toolbar with button groups"
                        >
                          <div
                            class="btn-group btn-group-toggle btn-block"
                            role="group"
                          >
                            <button
                              type="button"
                              class="btn btn-bucket"
                              v-on:click="onSelectedBalGradient('expo')"
                              v-bind:class="[
                                this.selectedBalGradient === 'expo'
                                  ? 'active'
                                  : '',
                              ]"
                            >
                              Match
                            </button>
                            <button
                              type="button"
                              class="btn btn-bucket"
                              v-on:click="onSelectedBalGradient('monthly')"
                              v-bind:class="[
                                this.selectedBalGradient === 'monthly'
                                  ? 'active'
                                  : '',
                              ]"
                            >
                              Monthly
                            </button>
                            <button
                              type="button"
                              class="btn btn-bucket"
                              v-on:click="onSelectedBalGradient('quarterly')"
                              v-bind:class="[
                                this.selectedBalGradient === 'quarterly'
                                  ? 'active'
                                  : '',
                              ]"
                            >
                              Quarterly
                            </button>
                            <button
                              type="button"
                              class="btn btn-bucket"
                              v-on:click="onSelectedBalGradient('constant')"
                              v-bind:class="[
                                this.selectedBalGradient === 'constant'
                                  ? 'active'
                                  : '',
                              ]"
                            >
                              Constant
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="row f-row justify-content-center"
              v-show="radioSelection === 'balance'"
            >
              <div
                class="col col-3 text-center"
                v-show="
                  selectedBalGradient === 'monthly' ||
                    selectedBalGradient === 'quarterly'
                "
              >
                <button
                  @click="onUserTaylorMade('bal')"
                  type="button"
                  class="btn btn-sm btn-home"
                >
                  Customize
                </button>
              </div>
              <div class="col col-3 text-center">
                <button
                  @click="saveProgram(1)"
                  type="button"
                  class="btn btn-sm btn-home"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Cash Flow Program -->
        <div
          class="row f-row"
          v-bind:class="[selectedAsset === 0 ? 'h-50' : 'h-100']"
        >
          <div
            class="col program-inner-div-2"
            v-bind:class="[
              radioSelection === 'cash_flow'
                ? 'program-bgnd-light'
                : 'program-bgnd-dark',
            ]"
          >
            <div class="row f-row">
              <div
                class="col col-12"
                @click="onClickCashFlowDiv"
                v-if="selectedAsset === 0"
              >
                <input
                  type="radio"
                  id="cash_flow"
                  value="cash_flow"
                  v-model="radioSelection"
                />
                <label for="cash_flow">
                  <span style="padding-left: 8px">
                    Hedging Program Objective:
                  </span>
                  <span style="color:var(--textactive)">Cash Flow</span></label
                >
              </div>
              <div class="col col-12 mb-1">
                Hedging Program:
              </div>
            </div>

            <div class="row f-row">
              <div class="col col-12">
                The exposure represents the net imbalance of all cash flows in
                foreign exchange, calculated as:
                <ul class="fa-ul">
                  <li>
                    <i class="fa-li fa fa-plus"></i>Accounts receivable and
                    highly probable inbound cash flows in foreign currency
                  </li>
                  <li>
                    <i class="fa-li fa fa-minus"></i>Accounts payable and highly
                    probable outbound cash flows in foreign currency
                  </li>
                </ul>
              </div>
            </div>
            <div class="row f-row">
              <div class="col col-12">
                Define execution rules:
              </div>
            </div>
            <div class="row f-row">
              <div class="col col-12">
                <ul class="fa-ul">
                  <li>
                    <i class="fa-li fa fa-check"></i>
                    <div class="row f-row">
                      <div class="col col-3">
                        <input
                          v-model.number.lazy="cashFlowPercentage"
                          placeholder="%"
                          type="number"
                          step="1"
                          min="0"
                          max="200"
                          class="custom-input"
                        />
                      </div>
                      <div class="col col-6 ml-1">
                        % (of cash flow exposure)
                      </div>
                    </div>
                  </li>
                  <li v-if="this.selectedCashFlowGradient !== 'budget'">
                    <i class="fa-li fa fa-check"></i>
                    <div class="row f-row">
                      <div class="col col-3">
                        <input
                          v-model.number.lazy="cashFlowMonths"
                          placeholder="month"
                          type="number"
                          step="1"
                          min="1"
                          max="60"
                          class="custom-input"
                        />
                      </div>
                      <div class="col col-6 ml-1">months.</div>
                    </div>
                  </li>
                  <li v-else>
                    <i class="fa-li fa fa-check"></i>
                    <div class="row f-row">
                      <div class="col col-auto">
                        Fiscal year begins in
                      </div>
                      <div class="col col-3 ml-1">
                        <select
                          class="dropdown-form dropdown-sm"
                          v-model="cashFlowBudgetMonth"
                        >
                          <option
                            v-for="(month, index) in dropdownMonths"
                            :value="index"
                            :key="'fiscal' + index"
                          >
                            {{ month | filterMonth }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </li>
                  <li>
                    <i class="fa-li fa fa-check"></i>
                    <div class="row f-row">
                      <div class="col col-11" style="padding: 2px;">
                        <div
                          class="btn-toolbar"
                          role="toolbar"
                          aria-label="Toolbar with button groups"
                        >
                          <div
                            class="btn-group btn-group-toggle btn-block"
                            role="group"
                          >
                            <button
                              type="button"
                              class="btn btn-bucket"
                              v-on:click="onSelectedCashFlowGradient('monthly')"
                              v-bind:class="[
                                this.selectedCashFlowGradient === 'monthly'
                                  ? 'active'
                                  : '',
                              ]"
                            >
                              Monthly
                            </button>
                            <button
                              type="button"
                              class="btn btn-bucket"
                              v-on:click="
                                onSelectedCashFlowGradient('quarterly')
                              "
                              v-bind:class="[
                                this.selectedCashFlowGradient === 'quarterly'
                                  ? 'active'
                                  : '',
                              ]"
                            >
                              Quarterly
                            </button>
                            <button
                              type="button"
                              class="btn btn-bucket"
                              v-on:click="onSelectedCashFlowGradient('budget')"
                              v-bind:class="[
                                this.selectedCashFlowGradient === 'budget'
                                  ? 'active'
                                  : '',
                              ]"
                            >
                              Budget
                            </button>
                            <button
                              type="button"
                              class="btn btn-bucket"
                              v-on:click="
                                onSelectedCashFlowGradient('constant')
                              "
                              v-bind:class="[
                                this.selectedCashFlowGradient === 'constant'
                                  ? 'active'
                                  : '',
                              ]"
                            >
                              Constant
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="row f-row justify-content-center"
              v-show="radioSelection === 'cash_flow' && selectedAsset === 0"
            >
              <div
                class="col col-3 text-center"
                v-show="
                  selectedCashFlowGradient === 'monthly' ||
                    selectedCashFlowGradient === 'quarterly'
                "
              >
                <button
                  @click="onUserTaylorMade('cash')"
                  type="button"
                  class="btn btn-sm btn-home"
                >
                  Customize
                </button>
              </div>
              <div class="col col-3 text-center">
                <button
                  @click="saveProgram(1)"
                  type="button"
                  class="btn btn-sm btn-home"
                >
                  Save
                </button>
              </div>
            </div>

            <!-- Save options for commodities -->
            <div
              class="row f-row justify-content-center"
              v-show="selectedAsset === 1"
            >
              <div
                class="col col-3 text-center"
                v-show="
                  selectedCashFlowGradient === 'monthly' ||
                    selectedCashFlowGradient === 'quarterly'
                "
              >
                <button
                  @click="onUserTaylorMade('cash')"
                  type="button"
                  class="btn btn-sm btn-home"
                >
                  Customize
                </button>
              </div>
              <div class="col col-3 text-center">
                <button
                  @click="saveProgram(2)"
                  type="button"
                  class="btn btn-sm btn-home"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col program-div" style="margin: 0 5px 0 5px;">
        <div class="row f-row" style="height: 96%;">
          <div class="col program-inner-div-3" style="width: 96%">
            <div class="row f-row" style="width: 100%">
              <div class="markets-chart-title col col-12">
                EXAMPLE
              </div>
            </div>
            <!-- Row: legend -->
            <div
              class="row f-row justify-content-center text-center mt-2"
              style="font-size: 0.7rem;"
            >
              <div class="col col-3">
                <div class="square-border-expo-3"></div>
                BALANCE ({{ balanceTotal | formatMoney }})
              </div>
              <div class="col col-3">
                <div
                  v-bind:class="[
                    radioSelection === 'cash_flow'
                      ? 'square-border-expo'
                      : 'square-border-expo-off',
                  ]"
                ></div>
                CASH FLOW ({{ (balanceTotal + cashFlowTotal) | formatMoney }})
              </div>
              <div class="col col-3">
                <i class="fa fa-minus mr-1" style="color:var(--net)"></i
                >STRATEGY ({{ hedgeTotal | formatMoney }})
              </div>
            </div>
            <!-- Row: chart -->
            <div class="d-flex flex-column" style="height: 90%;">
              <div class="row f-row h-100">
                <div class="col col-12 h-100" style="width:100%;">
                  <div
                    class="h-100 d-flex flex-column"
                    id="program_chart-div"
                    style="width: 100%;"
                  >
                    <svg id="svg-program_chart"></svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  currencyFormat,
  colorDarkExpo,
  colorDarkExpoAlpha,
  colorNet,
  colorNetAlpha,
  colorSymmetry,
  colorSymmetryAlpha,
  colorSymmetryAlpha3,
  formatPercent,
  numberFormat,
} from "@/_core/_helpers/_parametric_tools";
import { apiService } from "@/_services";
import { D3Chart } from "@/_core/charts/D3Chart";
import { getCommodityProgram } from "@/_core/data/api_calls/getCommodityProgram";
import { getCurrencyProgram } from "@/_core/data/api_calls/getCurrencyProgram";
import { sortByKey } from "@/_core/_helpers/_helpers.js";
import { format } from "d3";
import Dropdown from "primevue/dropdown";
import Messages from "@/components/modals/Messages.vue";
import moment from "moment";
import ProgramTaylorMade from "@/components/dataModel/ProgramTaylorMade";

export default {
  name: "DataModelProgram",
  components: {
    Dropdown,
    Messages,
    ProgramTaylorMade,
  },
  props: {
    colorTheme: { required: true, type: Boolean, default: true },
    portfolioList: { required: true },
    processData: { required: true },
    programType: { required: true },
    selectedAsset: { required: true },
    selectedCompany: { required: true },
    selectedPortfolios: { required: true },
    watcherCompanySelected: { required: true },
  },
  data() {
    return {
      currencies: [
        {
          id: 0,
          pk: 0,
          name: "N.A",
        },
      ],
      selCurr: -1,
      commodities: [
        {
          id: 0,
          pk: 0,
          name: "N.A",
        },
      ],
      selComm: -1,
      selPort: -1,
      portfolioNumbers: [0],
      currencyNumber: 12,
      jsonObj: { values: {} },
      objective: "",
      parameter: "",
      radioSelection: "balance",
      watcherTaylorMade: 0,
      programData: {
        flow: "",
        objective: "",
        parameters: "",
      },
      modal_tailored: {
        showModalTailored: false,
        messageModal: "",
        optionsModal: "",
      },
      modal_processing_message: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false,
      },
      modal_process_finished_message: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false,
      },
      processed_company: null,
      now: new Date(),
      // === balance program
      balancePercentage: 100,
      balanceMonths: 6,
      selectedBalGradient: "expo",
      // === cash flow program
      cashFlowPercentage: 50,
      cashFlowMonths: 12,
      selectedCashFlowGradient: "monthly",
      // === hedges
      balanceTotal: 0,
      cashFlowTotal: 0,
      cashFlowBudgetMonth: 0,
      averages: 0,
      exampleData: [],
      flow_v: [],
      programDataModel: 0,
      exampleDataRaw: [
        { id: 0, date: "", balance: 1000000, cashFlow: 0, hedge: 0 },
        { id: 1, date: "", balance: 750000, cashFlow: 250000, hedge: 0 },
        { id: 2, date: "", balance: 600000, cashFlow: 400000, hedge: 0 },
        { id: 3, date: "", balance: 450000, cashFlow: 550000, hedge: 0 },
        { id: 4, date: "", balance: 300000, cashFlow: 700000, hedge: 0 },
        { id: 5, date: "", balance: 100000, cashFlow: 900000, hedge: 0 },
        { id: 6, date: "", balance: 0, cashFlow: 1000000, hedge: 0 },
      ],
      dropdownMonths: [],
      svgNode: null,
      flow: { values: {} },
      // === global vars
      currencyFormat: currencyFormat,
      dateFormat: "%b %y",
      numberFormat: numberFormat,
      formatPercent: formatPercent,
      D3Chart: null,
      colorCF: colorSymmetryAlpha(this.colorTheme),
      db: false,
    };
  },
  created() {
    this.programDataModel = 1;
    if (this.selectedPortfolios.length > 0) {
      this.selPort = this.selectedPortfolios[0].pk;
    } else {
      this.selPort = this.portfolioList[0].pk;
    }
    this.getAssetsInPortfolio();
    // ===== create initial charts instances =====
    this.D3Chart = new D3Chart("program_chart-div", "svg-program_chart");
    this.calculateTotals();
    if (this.selectedAsset === 1) {
      this.radioSelection = "cash_flow";
    }
    let vis = this;
    for (var i = 0; i < 53; i++) {
      this.exampleDataRaw.push({
        id: 7 + i,
        date: "",
        balance: 0,
        cashFlow: 1000000,
        hedge: 0,
      });
    }
    this.exampleDataRaw.forEach(function(d, i) {
      d.date = new Date(vis.now.getFullYear(), vis.now.getMonth() + i + 1, 1);
    });
    for (i = 0; i < 12; i++) {
      if (this.exampleDataRaw[i].date.getMonth() === 0) {
        this.cashFlowBudgetMonth = i;
      }
    }
    this.dropdownMonths = this.exampleDataRaw.slice(0, 12).map((d) => d.date);
    try {
      this.user = this.$store.state.user.all.items;
    } catch (error) {
      console.log(`Error user ${error}`);
    }
  },
  mounted() {
    this.apiCalls();
  },
  computed: {
    hedgeTotal() {
      if (this.radioSelection === "balance") {
        return (this.balancePercentage / 100) * this.balanceTotal;
      } else {
        if (this.selectedCashFlowGradient === "budget") {
          let vis = this;
          let cashFlowTotal = 0;
          if (this.cashFlowBudgetMonth <= 2) {
            cashFlowTotal = this.exampleDataRaw
              .map((d) => d.cashFlow + d.balance)
              .filter((d, i) => i < (vis.cashFlowBudgetMonth % 12) + 12)
              .reduce((a, b) => a + b);
          } else {
            cashFlowTotal = this.exampleDataRaw
              .map((d) => d.cashFlow + d.balance)
              .filter((d, i) => i < vis.cashFlowBudgetMonth % 12)
              .reduce((a, b) => a + b);
          }
          return (this.cashFlowPercentage / 100) * cashFlowTotal;
        } else {
          return (
            (this.cashFlowPercentage / 100) *
            (this.balanceTotal + this.cashFlowTotal)
          );
        }
      }
    },
  },
  watch: {
    colorTheme() {
      if (this.radioSelection === "balance") {
        this.createHedgesBalance();
      } else {
        this.createHedgesCashFlow();
      }
    },
    watcherCompanySelected() {
      this.selPort = this.selectedPortfolios[0].pk;
      if (this.selectedPortfolios.length > 0) {
        this.selPort = this.selectedPortfolios[0].pk;
      } else {
        this.selPort = this.portfolioList[0].pk;
      }
      this.getAssetsInPortfolio();
      this.apiCalls();
    },
    selectedAsset(val) {
      if (val === 1) {
        this.radioSelection = "cash_flow";
      }
      this.apiCalls();
    },
    balancePercentage() {
      this.chooseMethod();
    },
    cashFlowPercentage() {
      this.chooseMethod();
    },
    balanceMonths(newValue, oldValue) {
      if (this.selectedBalGradient === "quarterly") {
        if (newValue < oldValue) {
          this.balanceMonths = Math.max(3, Math.floor(newValue / 3) * 3);
        } else {
          this.balanceMonths = Math.max(3, Math.ceil(newValue / 3) * 3);
        }
      } else {
        this.balanceMonths = newValue;
      }
      this.calculateTotals();
      this.chooseMethod();
    },
    radioSelection() {
      if (this.radioSelection === "balance") {
        this.colorCF = colorSymmetryAlpha(this.colorTheme);
      } else {
        this.colorCF = colorSymmetryAlpha3(this.colorTheme);
      }
      this.chooseMethod();
    },
    cashFlowMonths(newValue, oldValue) {
      if (this.selectedCashFlowGradient === "quarterly") {
        if (newValue < oldValue) {
          this.cashFlowMonths = Math.max(3, Math.floor(newValue / 3) * 3);
        } else {
          this.cashFlowMonths = Math.max(3, Math.ceil(newValue / 3) * 3);
        }
      } else {
        this.cashFlowMonths = newValue;
      }
      if (!this.db) {
        this.exampleData = this.exampleDataRaw.slice(0, Math.max(newValue, 0));
      }
      this.db = false;
      this.calculateTotals();
      this.chooseMethod();
    },
    cashFlowBudgetMonth() {
      this.chooseMethod();
    },
  },
  filters: {
    filterMonth: function(value) {
      if (value) {
        return moment(String(value)).format("MMMM");
      }
    },
    formatMoney: function(value) {
      if (value) {
        return format(".4s")(value).replace(/G/, "B");
      }
    },
  },
  methods: {
    getPortfolioCurrency() {
      let element;
      let opt = [];
      let _this = this;
      let port = this.portfolioList.find((d) => d.pk === _this.selPort);
      let all_currencies = _this.$store.state.currencies.all.items;
      for (let j = 0; j < port.currency.length; j++) {
        element = all_currencies.find(
          (d) => d.currency_name === port.currency[j],
        );
        opt.push({
          id: j,
          name: port.currency[j],
          pk: element.pk_i_idcurrency,
        });
      }
      opt = sortByKey(opt, "name");
      return opt.filter(_this.processData.onlyUnique);
    },
    getPortfolioCommodity() {
      let element;
      let opt = [];
      let _this = this;
      let port = this.portfolioList.find((d) => d.pk === _this.selPort);
      let all_commodities = _this.$store.state.commodities.all.items;
      for (let j = 0; j < port.commodity.length; j++) {
        element = all_commodities.find(
          (d) =>
            d.fk_idproduct.toUpperCase() === port.commodity[j].toUpperCase(),
        );
        opt.push({
          id: j,
          name: port.commodity[j].toUpperCase(),
          pk: element.pk_idcommodity,
        });
      }
      opt = sortByKey(opt, "name");
      return opt.filter(_this.processData.onlyUnique);
    },
    getAssetsInPortfolio() {
      let _this = this;
      if (this.selectedAsset === 0) {
        _this.currencies = [];
        let currAux = this.getPortfolioCurrency(_this);
        currAux.forEach(function(d, i) {
          _this.currencies.splice(i, 0, d);
        });
        this.selCurr = this.currencies[0].pk;
      } else {
        _this.commodities = [];
        let commAux = this.getPortfolioCommodity(_this);
        commAux.forEach(function(d, i) {
          _this.commodities.splice(i, 0, d);
        });
        this.selComm = this.commodities[0].pk;
      }
      this.emitProgramSelection();
    },
    emitProgramSelection() {
      let portfolio = null;
      let product = null;
      try {
        if (this.selPort != null && this.selPort !== -1) {
          portfolio = this.portfolioPkToString(this.selPort);
        }
      } catch (error) {
        portfolio = null;
      }
      try {
        if (this.selectedAsset === 0) {
          if (this.selCurr != null && this.selCurr !== -1) {
            product = this.currencyPkToString(this.selCurr);
          }
        } else if (this.selComm != null && this.selComm !== -1) {
          product = this.commodityPkToString(this.selComm);
        }
      } catch (error) {
        product = null;
      }
      this.$emit("eventOnProgramSelectionChange", { portfolio, product });
    },
    portfolioPkToString(pk) {
      return this.portfolioList.find((d) => d.pk === pk).name;
    },
    currencyPkToString(pk) {
      return this.currencies.find((d) => d.pk === pk).name;
    },
    commodityPkToString(pk) {
      return this.commodities.find((d) => d.pk === pk).name;
    },
    async apiCalls() {
      if (this.selectedAsset === 0) {
        Object.assign(this.modal_processing_message, {
          showModalLoading: true,
          messageModal: "Loading program...",
          optionsModal: false,
        });
        this.currencyNumber = this.selCurr;
        this.portfolioNumbers = [this.selPort];
        await getCurrencyProgram(
          this,
          "programData",
          "modal_processing_message.showModalLoading",
        );
      } else {
        Object.assign(this.modal_processing_message, {
          showModalLoading: true,
          messageModal: "Loading program...",
          optionsModal: false,
        });
        this.commodityNumber = this.selComm;
        this.portfolioNumbers = [this.selPort];
        await getCommodityProgram(
          this,
          "programData",
          "modal_processing_message.showModalLoading",
        );
      }
    },
    retrieveProgram() {
      this.getAssetsInPortfolio();
      this.apiCalls();
    },
    retrieveCurrencyProgram() {
      this.emitProgramSelection();
      this.apiCalls();
    },
    retrieveCommodityProgram() {
      this.emitProgramSelection();
      this.apiCalls();
    },
    onUserAccept(val) {
      this.flow = val;
      this.exampleData = val;
      val.forEach((d) => (d.date = new Date(d.date)));
      let hTot = this.exampleData.map((d) => d.hedge).reduce((a, b) => a + b);
      if (this.radioSelection === "balance") {
        this.balancePercentage = (100 * hTot) / this.balanceTotal;
      } else {
        this.cashFlowPercentage =
          (100 * hTot) / (this.balanceTotal + this.cashFlowTotal);
      }
      this.createExampleChart();
    },
    onUserTaylorMade(val) {
      this.modal_tailored.messageModal = val;
      if (val === "bal") {
        this.modal_tailored.optionsModal = this.selectedBalGradient;
      } else {
        this.modal_tailored.optionsModal = this.selectedCashFlowGradient;
      }
      this.modal_tailored.showModalTailored = true;
      this.watcherTaylorMade += 1;
    },
    calculateTotals() {
      let vis = this;
      this.balanceTotal = this.exampleDataRaw
        .map((d) => d.balance)
        .reduce((a, b) => a + b);

      let selectedField;
      if (this.radioSelection === "balance") {
        selectedField = "balanceMonths";
      } else {
        selectedField = "cashFlowMonths";
      }

      this.cashFlowTotal = this.exampleDataRaw
        .map((d) => d.cashFlow)
        .filter((d, i) => i < vis[selectedField])
        .reduce((a, b) => a + b);
    },
    chooseMethod() {
      if (this.radioSelection === "balance") {
        this.createHedgesBalance();
      } else {
        this.createHedgesCashFlow();
      }
    },
    createHedgesBalance() {
      this.calculateTotals();
      let vis = this;
      if (this.selectedBalGradient === "single") {
        this.exampleDataRaw.forEach(function(d, i) {
          d.hedge = i === vis.balanceMonths - 1 ? vis.hedgeTotal : 0;
        });
      } else if (this.selectedBalGradient === "expo") {
        this.exampleDataRaw.forEach(function(d) {
          d.hedge = (vis.balancePercentage / 100) * d.balance;
        });
      } else if (this.selectedBalGradient === "monthly") {
        let gradient =
          (this.hedgeTotal / (this.balanceMonths + 1) / this.balanceMonths) * 2;
        this.exampleDataRaw.forEach(function(d, i) {
          d.hedge =
            i <= vis.balanceMonths - 1 ? (vis.balanceMonths - i) * gradient : 0;
        });
      } else if (this.selectedBalGradient === "quarterly") {
        if (this.balanceMonths % 3 > 0) {
          this.balanceMonths = Math.ceil(this.balanceMonths / 3) * 3;
        }
        let balanceQuarters = this.balanceMonths / 3;
        let gradient =
          (this.hedgeTotal / (balanceQuarters + 1) / balanceQuarters) * 2;
        this.exampleDataRaw.forEach(function(d, i) {
          d.hedge =
            i <= vis.balanceMonths - 1
              ? ((balanceQuarters - Math.floor(i / 3)) * gradient) / 3
              : 0;
        });
      } else if (this.selectedBalGradient === "constant") {
        this.exampleDataRaw.forEach(function(d, i) {
          d.hedge =
            i <= vis.balanceMonths - 1 ? vis.hedgeTotal / vis.balanceMonths : 0;
        });
      }
      this.createExampleChart();
      this.createPercentages();
    },
    createHedgesCashFlow() {
      this.calculateTotals();
      let vis = this;
      if (this.selectedCashFlowGradient === "constant") {
        this.exampleDataRaw.forEach(function(d, i) {
          d.hedge =
            i <= vis.cashFlowMonths - 1
              ? vis.hedgeTotal / vis.cashFlowMonths
              : 0;
        });
      } else if (this.selectedCashFlowGradient === "budget") {
        this.balanceTotal = 0;
        this.cashFlowTotal = 0;
        if (this.cashFlowBudgetMonth % 12 <= 2) {
          vis.balanceTotal = this.exampleDataRaw
            .map((d) => d.balance)
            .filter((d, i) => i < (vis.cashFlowBudgetMonth % 12) + 12)
            .reduce((a, b) => a + b);
          vis.cashFlowTotal = this.exampleDataRaw
            .map((d) => d.cashFlow)
            .filter((d, i) => i < (vis.cashFlowBudgetMonth % 12) + 12)
            .reduce((a, b) => a + b);
        } else {
          vis.balanceTotal = this.exampleDataRaw
            .map((d) => d.balance)
            .filter((d, i) => i < vis.cashFlowBudgetMonth % 12)
            .reduce((a, b) => a + b);
          vis.cashFlowTotal = this.exampleDataRaw
            .map((d) => d.cashFlow)
            .filter((d, i) => i < vis.cashFlowBudgetMonth % 12)
            .reduce((a, b) => a + b);
        }

        if (this.cashFlowBudgetMonth % 12 <= 2) {
          this.exampleDataRaw.forEach(function(d, i) {
            d.hedge =
              i < (vis.cashFlowBudgetMonth % 12) + 12
                ? (vis.cashFlowPercentage / 100) * (d.balance + d.cashFlow)
                : 0;
          });
        } else {
          this.exampleDataRaw.forEach(function(d, i) {
            d.hedge =
              i < vis.cashFlowBudgetMonth % 12
                ? (vis.cashFlowPercentage / 100) * (d.balance + d.cashFlow)
                : 0;
          });
        }
      } else if (this.selectedCashFlowGradient === "monthly") {
        let gradient =
          (this.hedgeTotal / (this.cashFlowMonths + 1) / this.cashFlowMonths) *
          2;
        this.exampleDataRaw.forEach(function(d, i) {
          d.hedge =
            i <= vis.cashFlowMonths - 1
              ? (vis.cashFlowMonths - i) * gradient
              : 0;
        });
      } else if (this.selectedCashFlowGradient === "quarterly") {
        if (this.cashFlowMonths % 3 > 0) {
          this.cashFlowMonths = Math.ceil(this.cashFlowMonths / 3) * 3;
        }
        let cashFlowQuarters = this.cashFlowMonths / 3;
        let gradient =
          (this.hedgeTotal / (cashFlowQuarters + 1) / cashFlowQuarters) * 2;
        this.exampleDataRaw.forEach(function(d, i) {
          d.hedge =
            i <= vis.cashFlowMonths - 1
              ? ((cashFlowQuarters - Math.floor(i / 3)) * gradient) / 3
              : 0;
        });
      }
      this.createExampleChart();
      this.createPercentages();
    },
    createExampleChart() {
      // === set SVG canvas
      this.svgNode = this.D3Chart.setSVG(0.5, 10, 0.5, 20, 0.5, 30, 0.5, 70);
      // === set axis
      let minMaxYAxis = [-10000, 1010000];

      let idx = 0;
      if (this.radioSelection === "balance") {
        if (this.selectedBalGradient === "single") {
          idx = this.balanceMonths;
        } else {
          this.exampleDataRaw.forEach(function(d) {
            idx += d.hedge > 0 ? 1 : 0;
          });
        }
      } else {
        this.exampleDataRaw.forEach(function(d) {
          idx += d.hedge > 0 ? 1 : 0;
        });
      }

      if (!this.exampleData || Object.keys(this.exampleData).length == 0) {
        this.exampleData = this.exampleDataRaw.slice(0, Math.max(6, idx));
        this.cashFlowMonths = Object.keys(this.exampleData).length;
      }

      let localexampleData = this.exampleData;

      minMaxYAxis = this.processData.minMax(
        localexampleData,
        "hedge",
        "hedge",
        minMaxYAxis,
      );
      this.svgNode = this.D3Chart.setAxis(
        this.svgNode,
        localexampleData,
        minMaxYAxis,
        this.dateFormat,
        30,
        8,
      );
      this.D3Chart.twoStackedBars(
        this.svgNode,
        localexampleData,
        0.7,
        "BAL",
        "CF",
        colorDarkExpo(this.colorTheme),
        colorDarkExpoAlpha(this.colorTheme),
        colorSymmetry(this.colorTheme),
        this.colorCF,
        "date",
        "balance",
        "cashFlow",
        true,
        1,
      );
      this.D3Chart.bars(
        this.svgNode,
        localexampleData,
        0.9,
        "REF",
        colorNet(this.colorTheme),
        colorNetAlpha(this.colorTheme),
        "date",
        "hedge",
        true,
        false,
        1,
      );
    },
    createPercentages() {
      let expoTotal;
      let exampleDataFiltered = this.exampleData;
      if (this.radioSelection === "cash_flow") {
        expoTotal = this.exampleData
          .map((d) => d.balance + d.cashFlow)
          .reduce((a, b) => a + b);
        if (this.selectedCashFlowGradient === "monthly") {
          exampleDataFiltered.forEach(
            (d) =>
              (d.percentage =
                Math.round((10000 * d.hedge) / (d.balance + d.cashFlow)) / 100),
          );
        }
        if (this.selectedCashFlowGradient === "quarterly") {
          exampleDataFiltered = [];
          let sub_ex_data = this.exampleData;
          this.exampleData.forEach(function(d) {
            if (d.id % 3 === 0) {
              d.hedge *= 3;
              exampleDataFiltered.push(d);
            }
          });
          let idx;
          exampleDataFiltered.forEach(function(d, i) {
            idx = Math.floor(i / 3);
            d.percentage = Math.round(
              (100 * d.hedge) /
                (sub_ex_data[idx].balance +
                  sub_ex_data[idx].cashFlow +
                  sub_ex_data[idx + 1].balance +
                  sub_ex_data[idx + 1].cashFlow +
                  sub_ex_data[idx + 2].balance +
                  sub_ex_data[idx + 2].cashFlow),
            );
          });
        }
      } else {
        expoTotal = this.exampleData
          .map((d) => d.balance)
          .reduce((a, b) => a + b);
        if (this.selectedBalGradient === "monthly") {
          expoTotal = this.exampleData
            .map((d) => d.balance)
            .reduce((a, b) => a + b);
          exampleDataFiltered.forEach(
            (d) =>
              (d.percentage = Math.round((10000 * d.hedge) / expoTotal) / 100),
          );
        }
        if (this.selectedBalGradient === "quarterly") {
          exampleDataFiltered = [];
          this.exampleData.forEach(function(d) {
            if (d.id % 3 === 0) {
              d.hedge *= 3;
              exampleDataFiltered.push(d);
            }
          });
          exampleDataFiltered.forEach(
            (d) =>
              (d.percentage = Math.round((10000 * d.hedge) / expoTotal) / 100),
          );
        }
      }
      this.flow = exampleDataFiltered;
    },
    onClickBalanceDiv() {
      this.radioSelection = "balance";
    },
    onClickCashFlowDiv() {
      this.radioSelection = "cash_flow";
    },
    onSelectedBalGradient(item) {
      this.selectedBalGradient = item;
      this.chooseMethod();
    },
    onSelectedCashFlowGradient(item) {
      this.selectedCashFlowGradient = item;
      this.chooseMethod();
    },
    saveProgram(idx) {
      this.jsonObj = { values: {} };
      if (this.radioSelection === "cash_flow" || this.selectedAsset === 1) {
        this.objective = "cash_flow";
        if (this.selectedCashFlowGradient === "budget") {
          this.parameter = "budget";
          this.jsonObj.values.percentage = this.cashFlowPercentage;
          this.jsonObj.values.percentagemonths = this.cashFlowMonths;
        } else if (this.selectedCashFlowGradient === "constant") {
          this.parameter = "constant";
          this.jsonObj.values.percentage = this.cashFlowPercentage;
          this.jsonObj.values.months = this.cashFlowMonths;
        } else if (this.selectedCashFlowGradient === "monthly") {
          if (this.flow.length === undefined) {
            this.jsonObj = { values: {} };
            this.jsonObj = {
              values: {
                "0": 92.31,
                "1": 84.62,
                "2": 76.92,
                "3": 69.23,
                "4": 61.54,
                "5": 53.85,
                "6": 46.15,
                "7": 38.46,
                "8": 30.77,
                "9": 23.08,
                "10": 15.38,
                "11": 7.69,
              },
            };
          } else {
            this.parameter = "monthly";
            this.jsonObj = { values: {} };
            for (let u = 0; u < this.flow.length; u++) {
              this.jsonObj.values[u] = this.flow[u]["percentage"];
            }
          }
        } else {
          this.parameter = "quarterly";
          if (this.flow.length === undefined) {
            this.jsonObj = { values: {} };
            this.jsonObj = { values: { "0": 80, "1": 60, "2": 40, "3": 20 } };
          } else {
            this.jsonObj = { values: {} };
            for (let u = 0; u < this.flow.length; u++) {
              this.jsonObj.values[u] = this.flow[u]["percentage"];
            }
          }
        }
      } else {
        this.objective = "Balance";
        if (this.selectedBalGradient === "expo") {
          this.parameter = "match";
          this.jsonObj.values.percentage = this.balancePercentage;
        } else if (this.selectedBalGradient === "constant") {
          this.parameter = "constant";
          this.jsonObj.values.percentage = this.balancePercentage;
          this.jsonObj.values.months = this.balanceMonths;
        } else if (this.selectedBalGradient === "quarterly") {
          if (this.flow.length === undefined) {
            this.jsonObj = { values: {} };
            this.jsonObj = { values: { "0": 66.67, "3": 33.33 } };
          } else {
            this.jsonObj = { values: {} };
            for (var d = 0; d < this.flow.length; d++) {
              this.jsonObj.values[d] = this.flow[d]["percentage"];
            }
          }
          this.parameter = "quarterly";
        } else {
          this.jsonObj = { values: {} };
          if (this.flow.length === undefined) {
            this.jsonObj = { values: {} };
            this.jsonObj = {
              values: {
                "0": 66.67,
                "1": 23.81,
                "2": 19.05,
                "3": 33.33,
                "4": 9.52,
                "5": 4.76,
              },
            };
          } else {
            for (var k = 0; k < this.flow.length; k++) {
              this.jsonObj.values[k] = this.flow[k]["percentage"];
            }
          }
          this.parameter = "monthly";
        }
      }
      if (this.parameter === "") this.parameter = "monthly";
      if (idx === 1) {
        let params = {
          method: "POST",
          endpoint: "create_currency_hedging_program",
          content_type: "application/json",
          query_params: {
            format: "json",
            user_id: this.user.pk_idusers,
            selected_company: this.selectedCompany.pk_idcompany,
            selected_portfolios: this.selPort,
            currency: this.selCurr,
            flow: this.jsonObj,
            parameter: this.parameter,
            objective: this.objective,
          },
        };
        apiService.getAll(params).then((data) => {
          console.log(typeof data);
        });
      } else {
        let params = {
          method: "POST",
          endpoint: "create_commodity_hedging_program",
          content_type: "application/json",
          query_params: {
            format: "json",
            user_id: this.user.pk_idusers,
            selected_company: this.selectedCompany.pk_idcompany,
            selected_portfolios: this.selPort,
            commodity: this.selComm,
            flow: this.jsonObj,
            parameter: this.parameter,
            objective: this.objective,
          },
        };
        apiService.getAll(params).then((data) => {
          console.log(typeof data);
        });
      }
      this.jsonObj = { values: {} };
      Object.assign(this.modal_processing_message, {
        showModalLoading: !this.modal_processing_message.showModalLoading,
        messageModal: "Successfully saved program",
        optionsModal: true,
      });
    },
  },
};
</script>

<style scoped>
.dropdown-form.dropdown-sm option {
  color: var(--darkbackground);
}
</style>
